import { render } from "./AppPageRestablecer.vue?vue&type=template&id=a0535d60"
import script from "./AppPageRestablecer.vue?vue&type=script&lang=js"
export * from "./AppPageRestablecer.vue?vue&type=script&lang=js"

import exportComponent from "/home/appalala/repositorios/alala/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__